import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { IDocumentCounList } from "./Table";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";


interface IDocumentList {
    document_Type?: string,
    document_ID?: number,
    pO_ID?: number,
    document_Name?: string,
    expiration_Date?: Date,
    document_Path?: string,
    document_Status?: string,
    addedByName?: string,
    editedByName?: string,
    company_ID?: number,
    sub_Vendor_ID?: number,
    consultant_ID?: number,
}

interface IProps {
    open: boolean,
    singleData: IDocumentCounList,
    type: number,
    hideDialogue: () => void,
    toast: any
}

export const DocumentList = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IDocumentList>, loading: boolean });
    const dt = useRef<any>(null);

    const onHide = () => {
        props.hideDialogue();
    }

    const expirationDate = (rowData: IDocumentList) => {
        let date;
        let isExp = false;
        if (rowData.expiration_Date) {
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth() + 1;
            const currentDay = new Date().getDate();

            const docYear = new Date(rowData.expiration_Date).getFullYear();
            const docMonth = new Date(rowData.expiration_Date).getMonth() + 1;
            const docDay = new Date(rowData.expiration_Date).getDate();

            if (new Date(currentYear, currentMonth, currentDay) > new Date(docYear, docMonth, docDay)) {
                isExp = true;
            }
        }
        if (rowData.expiration_Date) date = format(new Date(rowData.expiration_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<p style={{ color: isExp === true ? "red" : "" }}>{date}</p>);
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const respone = await Fetch("vwPODetails/getDocumentsListAPW", "GET", null, `po_id=${props.singleData.pO_Id}&type=${props.type}`, props.toast);

        if (respone) {
            const data: IDocumentList[] = await respone.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const downloadDocument = async (data: IDocumentList) => {

        const newData: any = {
            pO_ID: props.singleData.pO_Id,
            consultant_ID: props.singleData.consultant_ID,
            sub_Vendor_ID: props.singleData.prime_Vendor_Company_ID,
            prime_Vendor_ID: props.singleData.sub_Vendor_Company_ID,
        }
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(newData)
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetails/document"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = newData.document_Path ? newData.document_Path : "document";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const file = (rowData: IDocumentList) => {
        return (<span onClick={() => downloadDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline">Download</span>);
    };

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Document List" modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small"
                exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                showGridlines stripedRows responsiveLayout="scroll"
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={"Document Lists"}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: "4rem" }} />
                <Column field="document_Type" header="Document Type" />
                <Column field="document_Name" header="Document Name" />
                {/* <Column field="expiration_Date" header="Expiration Date" body={(rowData: any) => expirationDate(rowData)} /> */}
                <Column field="expiration_Date" header="Expiration Date" body={(rowData: any) => safeFormatDate(rowData.expiration_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="document_Path" header="Download" body={file} />
                <Column field="document_Status" header="Document Status" />
                <Column field="addedByName" header="Added By" />
                <Column field="editedByName" header="Edited By" />
            </DataTable>
        </Dialog>
    );
}